import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-238" data-mp="3k18au7gl9uk7">
      <p className={`text-[0.65rem] font-bold uppercase tracking-[0.18em] sm:text-xs sm:tracking-[0.2em] ${isDark ? 'text-gold-400' : 'text-forest-600'}`} data-id="element-239" data-mp="bk3q5rowh9bi">
        {eyebrow}
      </p>
      <h2 className={`mt-2 font-display text-[1.6rem] leading-[1.12] sm:mt-3 sm:text-4xl lg:text-[2.75rem] ${isDark ? 'text-cream-50' : 'text-forest-900'}`} style={{
      fontWeight: 700
    }} data-id="element-240" data-mp="1tsfznemi3w6">
        {title}
      </h2>
      {subtitle ? <p className={`mt-2.5 text-sm leading-relaxed sm:mt-4 sm:text-base ${isDark ? 'text-cream-200' : 'text-forest-900/70'}`} data-id="element-241" data-mp="za7trz23992i">
          {subtitle}
        </p> : null}
    </div>;
}